<form class="filter-panel row align-items-end" [formGroup]="form">
    <div class="col-12 col-lg-3">
        <ui-form-group-wrapper [marginClass]="'mb-lg-0'" [label]="'global.labels.status' | translate">
            <ng-select
                bindLabel="name"
                bindValue="stCode"
                [clearAllText]="'global.actions.clear' | translate"
                [notFoundText]="'global.labels.no_items_found' | translate"
                [placeholder]="'global.labels.all' | translate"
                [class.ng-select--loading]="!statuses"
                [searchable]="false"
                [items]="statuses"
                [ngClass]="'ng-select--form-control'"
                [formControlName]="b2bInvoiceFilterFormField.StCode" />
        </ui-form-group-wrapper>
    </div>

    <div class="col-12 col-lg-auto">
        <ui-calendar-range-control
            [dateFormat]="calendarFormat"
            [formControlName]="b2bInvoiceFilterFormField.Date"
            [label]="'global.labels.date' | translate" />
    </div>
    <div class="col-12 col-lg-auto mt-6">
        <ui-button
            [type]="'outline'"
            [disabled]="form.status === 'INVALID' || pending"
            [prefix]="bsIconTypes.Search"
            [label]="'global.actions.search' | translate"
            (handlerClick)="handlerSubmit()" />
    </div>
</form>
